<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b('requisites')">
    <h4 :class="b('requisites-title')">Банковские реквизиты</h4>
    <div :class="b('requisites-content')">
      <div :class="b('field')">
        <h4 :class="b('field-title')">
          {{ $t("Название*") }}
        </h4>

        <UIInput view="light" v-model="bankRequisite.name" disabled />
      </div>

      <div :class="b('field')">
        <h4 :class="b('field-title')">
          {{ $t("Номер расчетного счета*") }}
        </h4>

        <UIInput view="light" v-model="bankRequisite.account_number" disabled />
      </div>

      <div :class="b('field')">
        <h4 :class="b('field-title')">
          {{ $t("Номер корреспондентского счета*") }}
        </h4>

        <UIInput
          view="light"
          v-model="bankRequisite.correspondent_account"
          disabled
        />
      </div>

      <div :class="b('field')">
        <h4 :class="b('field-title')">
          {{ $t("Банковский идентификационный код (БИК)*") }}
        </h4>

        <UIInput
          view="light"
          v-model="bankRequisite.bank_identification_code"
          disabled
        />
      </div>

      <div :class="b('field')">
        <h4 :class="b('field-title')">
          {{ $t("Полное наименование банка*") }}
        </h4>
        <UIInput view="light" v-model="bankRequisite.bank_name" disabled />
      </div>

      <div :class="b('field')">
        <h4 :class="b('field-title')">
          {{ $t("Идентификационный номер") }}
          <br />
          {{ $t("налогоплательщика (ИНН)*") }}
        </h4>
        <UIInput view="light" v-model="bankRequisite.inn" disabled />
      </div>

      <div :class="b('field')">
        <h4 :class="b('field-title')">
          {{ $t("Код причины постановки на учет (КПП)*") }}
        </h4>
        <UIInput
          view="light"
          v-model="bankRequisite.registration_reason_code"
          disabled
        />
      </div>

      <div :class="b('field')">
        <h4 :class="b('field-title')">Примечание</h4>

        <UITextArea
          view="light"
          disabled
          rows="4"
          placeholder="Добавьте комментарий при необходимости"
          v-model="bankRequisite.note"
        />
      </div>
    </div>
  </div>
</template>
